import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { LocationProvider } from "@/context/LocationContext";
import Layout from "@/components/Layout";
import TrailingSlashRedirect from "@/components/TrailingSlashRedirect";
import Home from "@/pages/Home";
import Ouverture from "@/pages/Ouverture";
import Depannage from "@/pages/Depannage";
import Remplacement from "@/pages/Remplacement";
import Contact from "@/pages/Contact";
import FAQPage from "@/pages/FAQ";
import MentionsLegales from "@/pages/MentionsLegales";
import Admin from "@/pages/Admin";
import SerrurierOrleans from "@/pages/SerrurierOrleans";
import SerrurierVille from "@/pages/SerrurierVille";
import SerrurierCharenton from "@/pages/SerrurierCharenton";
import CITIES from "@/data/loiret-cities";
import PARIS_CITIES from "@/data/paris-cities";

function App() {
    return (
        <div className="App">
            <LocationProvider>
                <BrowserRouter>
                    <TrailingSlashRedirect />
                    <Routes>
                        <Route element={<Layout />}>
                            <Route path="/" element={<Home />} />
                            <Route path="/ouverture-de-porte" element={<Ouverture />} />
                            <Route path="/depannage-serrurier" element={<Depannage />} />
                            <Route path="/remplacement-serrure" element={<Remplacement />} />
                            <Route path="/contact" element={<Contact />} />
                            <Route path="/faq" element={<FAQPage />} />
                            <Route path="/mentions-legales" element={<MentionsLegales />} />
                        </Route>
                        {/* Espace admin privé */}
                        <Route path="/admin-ab2026" element={<Admin />} />
                        {/* Landing SEO — Serrurier Orléans (page custom) */}
                        <Route path="/serrurier-orleans-45" element={<SerrurierOrleans />} />
                        {/* Landing SEO — Serrurier Charenton-le-Pont (page custom, isolée) */}
                        <Route path="/serrurier-charenton-le-pont-94" element={<SerrurierCharenton />} />
                        {/* Landings SEO — villes du Loiret (générique, une route par ville) */}
                        {CITIES.map((c) => (
                            <Route
                                key={c.slug}
                                path={`/serrurier-${c.slug}-45`}
                                element={<SerrurierVille />}
                            />
                        ))}
                        {/* Landings SEO — arrondissements de Paris (20 pages) */}
                        {PARIS_CITIES.map((c) => (
                            <Route
                                key={c.slug}
                                path={`/${c.slug}`}
                                element={<SerrurierVille />}
                            />
                        ))}
                    </Routes>
                </BrowserRouter>
                <Toaster position="top-right" />
            </LocationProvider>
        </div>
    );
}

export default App;
